import * as Yup from "yup";

import {
  DecisionCriteria,
  OrderedDecisionCriteria,
  PropertyTypes,
  ReoOwnershipStatuses,
} from "@eave/shared/types/api";

export const propertyTypeOptions = Object.keys(PropertyTypes).map(t => PropertyTypes[t]);
export const reqStr = "required";

const numberZeroOrGreater = Yup.number().typeError("must be a number").min(0);

const percentOrValueSchema = Yup.object().shape({
  percent: numberZeroOrGreater.max(100, "must be less than or equal to 100").nullable(),
  value: numberZeroOrGreater.nullable(),
});

export const validationSchema = Yup.object().shape({
  loan_amount: numberZeroOrGreater.required(reqStr),
  downpayment: numberZeroOrGreater.required(reqStr),
  appraised_value: numberZeroOrGreater.required(reqStr),
  property_type: Yup.string().oneOf(propertyTypeOptions).required(reqStr),
  property_taxes: percentOrValueSchema,
  homeowners_insurance: percentOrValueSchema,
  hoa: percentOrValueSchema,
  supplemental_property_insurance: percentOrValueSchema,
  mortgage_insurance: percentOrValueSchema,
  price_exception: Yup.number()
    .required(reqStr)
    .test({
      name: "eighths",
      test: value => value % 0.125 === 0,
      message: "must be divisible by 0.125",
    }),
  decision_criteria: Yup.string().oneOf(OrderedDecisionCriteria).required(reqStr),
  monthly_income: numberZeroOrGreater.required(reqStr),
  monthly_liabilities: numberZeroOrGreater.required(reqStr),
  total_liabilities_excluded_from_dti: numberZeroOrGreater.required(reqStr),
  total_assets: numberZeroOrGreater.required(reqStr),
  total_assets_for_reserves: numberZeroOrGreater.required(reqStr),
  reos: Yup.array(
    Yup.object().shape({
      id: numberZeroOrGreater.required(reqStr),
      ownership_status: Yup.string().oneOf(Object.keys(ReoOwnershipStatuses)).required(reqStr),
    }),
  ),
  va_funding_fee_to_finance: Yup.number().when("decision_criteria", {
    is: DecisionCriteria.Eave20220112VA,
    then: Yup.number().required(reqStr),
  }),
  used_entitlement_amount: Yup.number().when("full_entitlement", {
    is: false,
    then: Yup.number().required(reqStr),
  }),
});
